import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { ApprovalRequestStatus } from './approval-request-status';
import { ApprovalRequestType } from './approval-request-type';
import { Person } from './person';

@inheritSerialization(AbstractModel)
export class ApprovalRequestInfo extends AbstractModel {
  @autoserialize
  objectId: number;

  @autoserializeAs(ApprovalRequestType)
  approvalRequestType: ApprovalRequestType;

  @autoserialize
  active: boolean;

  @autoserializeAs(Person)
  reviewer: Person;

  @autoserializeAs(ApprovalRequestStatus)
  approvalRequestStatus: ApprovalRequestStatus;

  @autoserialize
  rejectionComments: string;

  @autoserializeAs(Date)
  reviewedAt: Date;

  @autoserialize
  requestNote: string;

  static OnSerialized(instance: ApprovalRequestInfo, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.reviewedAt)) {
      json.reviewedAt = DateUtil.serializeInstant(instance.reviewedAt);
    }
  }

  static OnDeserialized(instance: ApprovalRequestInfo, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['reviewedAt'])) {
      instance.reviewedAt = DateUtil.deserializeInstant(json['reviewedAt']);
    }
  }
}
